module.exports = __webpack_public_path__ + "static/2-e06a8cfdeca6e63110c12f34dfc709c9.svg";